import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {

  isContainer: boolean = true

  currentComp(comp: any){
    setTimeout(() => {
      this.isContainer =  comp && comp.noContainer ? false: true
    }, 100);
  }
}
